import { Stack } from "@mui/material";
import "./styles/Work.module.css";
import { useEffect } from "react";
import logo from "./assets/svgs/softwareag.svg";

function Work() {
  // TODO: Add real points and change the content of about my work as well

  useEffect(() => {
    document.title = "What I do - Shreyash";
  });

  const listOfApproach = [
    {
      title: "Software Engineer 2 - Software AG",
      description1: (
        <p>
          As a <strong>software engineer 2</strong> at <em>Software AG</em>, I{" "}
          <strong>designed and implemented</strong> a new UI for the{" "}
          <em>Agile Tester Tool</em>, a software testing platform that helps
          developers and testers deliver high-quality products faster and
          easier. I <strong>increased efficiency by 25%</strong> and{" "}
          <strong>enhanced user experience</strong> with intuitive features and
          responsive design.
        </p>
      ),
      description2: (
        <p>
          I also <strong>developed and deployed</strong> a <em>Chatbot</em> to{" "}
          <strong>resolve customer issues</strong> related to products,{" "}
          <strong>leading to a 70% reduction in tickets</strong> for the
          Customer support team and{" "}
          <strong>improving customer satisfaction</strong>. Additionally, I{" "}
          <strong>implemented and tested</strong> a{" "}
          <em>system failure prediction</em> algorithm to{" "}
          <strong>achieve a dedication to providing 99.99% availability</strong>{" "}
          to customers,{" "}
          <strong>demonstrating exceptional accuracy and reliability</strong>.
        </p>
      ),
      illustrationSvg: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M495.76,114.63H362.5L308.56,80.41a13,13,0,0,0-5.28-8A13,13,0,0,0,279.84,78L222,114.63H83.22a14.2,14.2,0,0,0-14.11,14.29V371.07a14.2,14.2,0,0,0,14.11,14.28H495.76a14.19,14.19,0,0,0,14.11-14.28V128.92A14.2,14.2,0,0,0,495.76,114.63ZM281.7,86.75a13.17,13.17,0,0,0,3.51,3.7,13,13,0,0,0,21.87-1l39.7,25.18h-109Z"
          ></path>
          <rect class="svg-bg" y="467.84" width="596.6" height="86.55"></rect>
        </svg>
      ),
      illustrationLayers: [
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 1920 1080"
          enable-background="new 0 0 1920 1080"
        >
          <path
            fill="#102451"
            opacity="1.000000"
            stroke="none"
            d=" M1.500000,1.000000   C1.999988,360.697601 1.999975,720.395203 1.999975,1080.546387   C1.666653,1080.833374 1.056187,1080.684204 1.044447,1080.497192   C0.960992,1079.169067 1.000000,1077.833374 1.000000,1076.500000   C1.000000,718.000000 1.000000,359.500000 1.500000,1.000000  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M940.692871,443.213928   C944.565552,442.657257 944.858765,444.615509 944.830322,447.339081   C944.721252,457.799622 944.786072,468.261932 944.786072,479.255951   C956.527710,479.255951 967.922180,479.255951 979.574341,479.255951   C979.574341,488.194855 979.574341,496.601166 979.574341,505.540466   C968.061707,505.540466 956.659180,505.540466 945.026978,505.540466   C945.026978,528.831482 945.026978,551.593567 945.026978,574.808777   C956.415833,574.808777 967.834351,574.808777 979.545532,574.808777   C979.545532,583.677734 979.545532,592.103638 979.545532,600.854980   C978.954773,600.981323 978.197815,601.284851 977.441284,601.283936   C965.114075,601.269043 952.777832,601.497803 940.462036,601.099792   C924.942932,600.598206 916.199768,591.569885 916.063110,576.026062   C915.872620,554.370178 916.001038,532.711426 915.993042,511.053894   C915.992432,509.416321 915.992920,507.778717 915.992920,505.885986   C896.230591,505.885986 876.821838,505.885986 856.954102,505.885986   C856.954102,537.424866 856.954102,568.996277 856.954102,600.940186   C847.111755,600.940186 837.718445,600.940186 827.970947,600.940186   C827.970947,569.318848 827.970947,537.718689 827.970947,505.646942   C819.231873,505.646942 810.829773,505.646942 802.198486,505.646942   C802.198486,496.747070 802.198486,488.318298 802.198486,479.436829   C810.654968,479.436829 819.072449,479.436829 827.993042,479.436829   C827.993042,472.045929 827.972595,465.093475 827.997009,458.141144   C828.060120,440.145752 836.464722,431.258392 854.308777,430.807953   C865.963196,430.513794 877.630127,430.713776 889.291443,430.706543   C889.762329,430.706238 890.233398,430.851196 890.934631,430.966309   C890.934631,439.439911 890.934631,447.873169 890.934631,456.785583   C879.684814,456.785583 868.463501,456.785583 856.983765,456.785583   C856.983765,464.344727 856.983765,471.434418 856.983765,478.905823   C876.423035,478.905823 895.959229,478.905823 915.946289,478.905823   C915.946289,467.222992 915.946289,455.472412 915.946289,443.213806   C924.331421,443.213806 932.278748,443.213806 940.692871,443.213928  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1085.229492,518.928101   C1084.673340,517.143982 1084.231812,515.736450 1083.477905,513.332581   C1074.735474,543.238464 1066.276611,572.174316 1057.759521,601.309326   C1048.040649,601.309326 1038.561890,601.470276 1029.101562,601.125854   C1027.770630,601.077393 1025.852539,598.768738 1025.346924,597.150024   C1015.443848,565.445251 1005.710388,533.687500 995.941223,501.940918   C993.656921,494.517548 991.368896,487.095276 988.964661,479.289612   C998.825073,479.289612 1008.146606,479.129883 1017.449768,479.472076   C1018.755798,479.520111 1020.661499,481.826172 1021.125122,483.424744   C1027.880005,506.715881 1034.433228,530.065491 1041.046753,553.397644   C1041.578979,555.274963 1042.201172,557.126709 1043.253174,560.505005   C1046.775024,548.381470 1049.889282,537.718140 1052.968994,527.044800   C1057.113770,512.681091 1061.377563,498.348938 1065.263550,483.915253   C1066.293579,480.089661 1068.017212,479.040771 1071.813477,479.193604   C1079.630127,479.508240 1087.486938,479.611542 1095.290283,479.160614   C1099.605347,478.911224 1100.922729,480.661591 1101.969482,484.393311   C1108.564087,507.901886 1115.377808,531.348999 1122.130859,554.813049   C1122.517090,556.155029 1123.005249,557.467590 1124.487305,558.847168   C1132.040527,532.462097 1139.593750,506.077087 1147.195435,479.522705   C1157.440552,479.522705 1167.516113,479.522705 1178.103027,479.522705   C1165.553345,520.197693 1153.086426,560.604980 1140.586304,601.119507   C1130.215454,601.119507 1120.083130,601.119507 1109.315308,601.119507   C1101.365601,573.986877 1093.354858,546.645752 1085.229492,518.928101  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1216.465698,481.398682   C1229.558105,476.305634 1242.642090,475.150085 1256.007324,478.029724   C1264.991455,479.965515 1272.683716,484.328735 1279.646240,492.304138   C1279.646240,487.258209 1279.646240,483.440430 1279.646240,479.465881   C1289.393921,479.465881 1298.514038,479.465881 1307.972656,479.465881   C1307.972656,519.906738 1307.972656,560.286743 1307.972656,600.988770   C1298.843628,600.988770 1289.607910,600.988770 1279.763062,600.988770   C1279.763062,597.244507 1279.763062,593.377563 1279.763062,589.500610   C1278.852173,589.500610 1278.421387,589.367126 1278.259644,589.519470   C1246.819702,619.138550 1193.350586,602.441040 1182.068359,559.466187   C1174.930664,532.278198 1183.254272,504.297394 1203.281250,489.133820   C1207.214600,486.155579 1211.829102,484.077026 1216.465698,481.398682  M1210.910645,527.611023   C1210.394409,530.046936 1209.663086,532.459412 1209.395264,534.922241   C1206.724976,559.477234 1221.620605,579.340271 1247.831665,578.040100   C1268.135010,577.032959 1281.592163,561.219299 1281.074829,538.515015   C1280.651978,519.959595 1269.228760,506.031677 1252.080078,503.162842   C1233.103394,499.988190 1217.738525,508.854279 1210.910645,527.611023  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1472.999512,548.400757   C1462.056519,548.400696 1451.613647,548.400696 1441.189209,548.400696   C1440.975342,559.443542 1449.547729,571.284668 1460.757935,575.967651   C1477.149780,582.815125 1495.160278,578.160339 1509.731079,563.130249   C1517.073853,568.436218 1524.456421,573.771057 1532.113037,579.303772   C1524.938843,588.632446 1516.270020,595.646667 1505.381958,599.495239   C1488.947144,605.304260 1472.092651,606.149231 1455.311157,601.445923   C1423.027710,592.397949 1407.745483,562.927917 1411.499268,532.001038   C1418.574829,473.708954 1482.076782,465.723969 1513.609619,487.311096   C1529.901611,498.464478 1537.518799,514.501648 1538.840942,533.809814   C1539.158203,538.442627 1538.888184,543.115662 1538.888184,548.400818   C1517.002075,548.400818 1495.250732,548.400818 1472.999512,548.400757  M1481.865479,501.341461   C1462.201660,499.372986 1446.467285,508.802887 1442.547119,524.887329   C1464.607666,524.887329 1486.672485,524.887329 1509.177368,524.887329   C1504.670044,511.722931 1495.938721,504.101166 1481.865479,501.341461  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M799.765869,532.383850   C801.684021,558.191956 794.028870,579.681885 771.828979,593.328857   C747.155945,608.495972 721.168457,608.552734 696.010864,594.210083   C673.612000,581.440308 662.559998,555.033264 667.301636,528.932617   C672.116577,502.428406 691.334900,482.791077 717.659363,478.054657   C740.749695,473.900208 762.120178,477.631378 780.204529,493.640839   C791.665222,503.786499 797.654175,516.897339 799.765869,532.383850  M712.488220,572.126709   C726.995178,580.215332 741.513000,580.322632 755.371887,571.054626   C770.128479,561.186279 774.848206,539.565063 766.572205,522.693604   C758.719666,506.685333 739.806396,499.015137 721.437561,504.607117   C707.964844,508.708527 699.684204,517.947937 697.067200,531.659363   C693.986450,547.800903 698.006653,561.690857 712.488220,572.126709  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M600.100342,604.083252   C578.694397,602.361511 561.395325,594.810425 551.351624,574.348877   C560.313171,569.524536 568.880310,564.912537 577.681091,560.174805   C582.490784,568.518250 588.754944,574.980530 598.243530,577.334473   C605.201477,579.060425 612.142761,578.691650 618.801819,575.931335   C623.001404,574.190552 626.338562,571.449829 626.386841,566.399231   C626.432617,561.603271 623.535461,558.367432 619.398438,557.033203   C612.005920,554.649048 604.344604,553.113525 596.868530,550.969299   C588.922607,548.690430 580.526672,547.167664 573.263489,543.473877   C551.742859,532.529053 548.887573,504.582367 567.179626,488.768799   C577.078247,480.211456 588.903687,476.777802 601.730469,476.567047   C621.784485,476.237549 639.239319,481.689178 650.821533,499.546936   C651.617798,500.774567 652.248474,502.109528 653.084595,503.627808   C645.249756,508.325409 637.578918,512.924683 629.774292,517.604126   C621.772034,505.769409 610.933350,500.885468 597.036255,502.949829   C589.781738,504.027466 584.673950,507.578064 584.045532,512.074829   C583.379028,516.844116 586.773376,521.309570 594.572571,523.557434   C603.805542,526.218445 613.354858,527.768005 622.732483,529.948120   C626.279175,530.772644 629.810547,531.800171 633.209290,533.100159   C646.507935,538.186768 654.551208,547.432190 655.538635,562.050171   C656.495300,576.212463 651.265198,587.442505 639.321960,595.234619   C627.539246,602.922119 614.293274,604.622559 600.100342,604.083252  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M320.108215,430.958984   C320.267517,403.341003 340.903137,380.499115 368.875031,379.354919   C396.301147,378.233063 423.809052,379.110535 451.586761,379.110535   C451.586761,396.179474 451.586761,413.097778 451.586761,430.775330   C408.100098,430.775330 364.522980,430.775330 320.478210,430.872101   C320.010559,430.968872 320.108215,430.958984 320.108215,430.958984  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M441.862274,601.053345   C441.422577,629.834900 419.279236,652.525818 390.589600,652.918335   C364.444214,653.276123 338.290131,652.999878 312.139862,652.991699   C311.514984,652.991516 310.890137,652.856384 310.109070,652.766113   C310.109070,635.624756 310.109070,618.705444 310.109070,601.241089   C353.860870,601.241089 397.443542,601.241089 441.492859,601.140259   C441.959473,601.039490 441.862274,601.053345 441.862274,601.053345  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1351.805908,601.309937   C1344.680542,601.309875 1338.030396,601.309875 1331.066772,601.309875   C1330.976318,599.565125 1330.836792,598.120789 1330.836182,596.676453   C1330.823730,566.677490 1330.800903,536.678467 1330.837158,506.679565   C1330.858398,489.149567 1338.423584,480.362518 1355.749512,479.618256   C1372.521729,478.897797 1389.349243,479.462036 1406.496338,479.462036   C1406.496338,488.209015 1406.496338,496.759552 1406.496338,505.828369   C1390.848511,505.828369 1375.267090,505.828369 1359.379517,505.828369   C1359.379517,537.785217 1359.379517,569.230347 1359.379517,601.309937   C1356.810913,601.309937 1354.546143,601.309937 1351.805908,601.309937  z"
          />
          <path
            fill="#6380D5"
            opacity="1.000000"
            stroke="none"
            d=" M351.166687,479.578674   C373.286255,486.486664 395.405792,493.394684 417.779541,501.016113   C418.020844,516.975647 418.051453,532.222107 417.950836,547.467590   C417.934723,549.911011 417.331696,552.350586 416.999969,554.791931   C397.647095,544.423218 376.058960,541.035461 355.306549,535.037598   C354.036682,534.670593 352.767395,534.301636 351.220947,533.259033   C351.018250,514.915894 351.092468,497.247284 351.166687,479.578674  z"
          />
          <path
            fill="#4DA5C3"
            opacity="1.000000"
            stroke="none"
            d=" M417.263916,555.014954   C417.331696,552.350586 417.934723,549.911011 417.950836,547.467590   C418.051453,532.222107 418.020844,516.975647 418.056976,501.243164   C432.356598,504.739655 445.624969,510.871887 457.578278,519.773315   C456.916840,521.983704 456.065552,523.794739 456.059235,525.608704   C455.971893,550.702454 456.000610,575.796570 456.000885,600.890625   C451.603882,600.950439 447.206848,601.010315 442.336060,601.061768   C441.862274,601.053345 441.959473,601.039490 441.956116,601.088928   C441.317169,586.556885 438.275238,572.871094 426.936096,562.496460   C424.024048,559.832092 420.675751,557.644592 417.263916,555.014954  z"
          />
          <path
            fill="#47AFBE"
            opacity="1.000000"
            stroke="none"
            d=" M456.464905,600.961731   C456.000610,575.796570 455.971893,550.702454 456.059235,525.608704   C456.065552,523.794739 456.916840,521.983704 457.772186,520.055176   C476.431274,532.443298 487.147156,550.033691 491.762848,571.313782   C493.816742,580.782898 494.416351,590.567444 495.783722,601.032837   C482.017670,601.032837 469.473297,601.032837 456.464905,600.961731  z"
          />
          <path
            fill="#7D57E9"
            opacity="1.000000"
            stroke="none"
            d=" M320.012543,430.919830   C320.475586,440.420441 322.049622,449.687042 326.986755,458.939117   C327.020844,478.367767 327.096466,496.967834 326.908051,515.565186   C326.879395,518.395508 325.626831,521.213501 324.940369,524.037170   C316.320435,518.929077 307.700470,513.820923 299.312805,508.292908   C300.029999,506.072113 300.930115,504.272888 300.937134,502.470154   C301.029510,478.683502 300.996155,454.896332 300.994293,431.109314   C307.048767,431.050598 313.103241,430.991852 319.632965,430.946045   C320.108215,430.958984 320.010559,430.968872 320.012543,430.919830  z"
          />
          <path
            fill="#8647F0"
            opacity="1.000000"
            stroke="none"
            d=" M300.530670,431.038330   C300.996155,454.896332 301.029510,478.683502 300.937134,502.470154   C300.930115,504.272888 300.029999,506.072113 299.142365,507.994904   C290.099243,501.857910 283.848541,493.551849 278.834412,484.308014   C269.912415,467.859741 267.034912,450.037964 267.004028,430.967316   C278.270538,430.967316 289.168793,430.967316 300.530670,431.038330  z"
          />
          <path
            fill="#7465E2"
            opacity="1.000000"
            stroke="none"
            d=" M325.179688,524.295044   C325.626831,521.213501 326.879395,518.395508 326.908051,515.565186   C327.096466,496.967834 327.020844,478.367767 327.054138,459.285828   C333.216583,467.591370 341.177460,474.264801 350.928284,479.357574   C351.092468,497.247284 351.018250,514.915894 350.909485,533.099182   C342.389648,530.593567 333.904297,527.573181 325.179688,524.295044  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M1654.904907,507.616394   C1651.840210,520.929138 1643.888184,527.522522 1631.434570,527.483276   C1619.358521,527.445190 1609.799194,519.846191 1607.314209,508.309509   C1604.904297,497.121338 1610.579590,485.669067 1620.867676,480.959625   C1631.792603,475.958679 1644.961792,479.034882 1652.212891,488.668457   C1649.652588,490.377563 1647.099609,492.081818 1644.565063,493.773834   C1636.162231,487.274048 1629.390747,486.141449 1623.348022,490.190002   C1617.862427,493.865204 1615.370361,501.249725 1617.370605,507.901398   C1619.240967,514.121094 1624.475708,518.072449 1631.104736,518.268372   C1637.791626,518.465881 1641.451416,516.127014 1643.829834,509.812927   C1638.943726,509.812927 1634.202148,509.812927 1629.198730,509.812927   C1629.198730,507.130188 1629.198730,504.858643 1629.198730,502.226013   C1637.549683,502.226013 1646.086182,502.226013 1654.942383,502.226013   C1654.942383,503.933105 1654.942383,505.555939 1654.904907,507.616394  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M1571.225342,488.134521   C1571.849609,486.722137 1572.342529,485.669281 1572.796631,484.599976   C1574.860107,479.739624 1579.626953,477.564362 1584.530396,479.414978   C1585.312744,479.710205 1586.063965,480.641144 1586.410767,481.456360   C1592.648315,496.124298 1598.823853,510.818665 1604.988403,525.517639   C1605.095703,525.773376 1604.902832,526.155029 1604.820190,526.661194   C1601.393799,526.661194 1597.942261,526.661194 1594.341553,526.661194   C1592.878052,523.158630 1591.412720,519.651611 1589.904175,516.040894   C1586.729004,516.040894 1583.697510,516.348633 1580.750977,515.979248   C1573.823242,515.110779 1568.440674,516.197815 1567.026001,524.395264   C1566.855225,525.385315 1564.795044,526.551575 1563.483643,526.736389   C1560.875244,527.103943 1558.178467,526.845093 1554.898804,526.845093   C1560.395630,513.811462 1565.735962,501.148956 1571.225342,488.134521  M1585.770874,505.142273   C1584.058228,500.834778 1582.345703,496.527313 1580.250488,491.257538   C1578.086060,496.879578 1576.219727,501.727417 1573.897827,507.758728   C1578.637451,507.057953 1582.306274,506.515503 1585.770874,505.142273  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M1210.993652,527.217163   C1217.738525,508.854279 1233.103394,499.988190 1252.080078,503.162842   C1269.228760,506.031677 1280.651978,519.959595 1281.074829,538.515015   C1281.592163,561.219299 1268.135010,577.032959 1247.831665,578.040100   C1221.620605,579.340271 1206.724976,559.477234 1209.395264,534.922241   C1209.663086,532.459412 1210.394409,530.046936 1210.993652,527.217163  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M1482.287476,501.448914   C1495.938721,504.101166 1504.670044,511.722931 1509.177368,524.887329   C1486.672485,524.887329 1464.607666,524.887329 1442.547119,524.887329   C1446.467285,508.802887 1462.201660,499.372986 1482.287476,501.448914  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M712.166443,571.953491   C698.006653,561.690857 693.986450,547.800903 697.067200,531.659363   C699.684204,517.947937 707.964844,508.708527 721.437561,504.607117   C739.806396,499.015137 758.719666,506.685333 766.572205,522.693604   C774.848206,539.565063 770.128479,561.186279 755.371887,571.054626   C741.513000,580.322632 726.995178,580.215332 712.166443,571.953491  z"
          />
          <path
            fill="#102451"
            opacity="1.000000"
            stroke="none"
            d=" M1585.873047,505.557678   C1582.306274,506.515503 1578.637451,507.057953 1573.897827,507.758728   C1576.219727,501.727417 1578.086060,496.879578 1580.250488,491.257538   C1582.345703,496.527313 1584.058228,500.834778 1585.873047,505.557678  z"
          />
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M540.5,391.81l32-40.84a6.31,6.31,0,0,0-7.91-9.48l-28.11,14.79,5.74-32.7a6.31,6.31,0,0,0-11.19-5l-14.53,18.5-10-32.5a6.32,6.32,0,0,0-12.08,0L484,338.76l-15.14-19.29a6.32,6.32,0,0,0-11.19,5l5.46,31.09-26.74-14.07a6.31,6.31,0,0,0-7.91,9.48l32,40.84a36.36,36.36,0,0,0,5.38,5.51A13,13,0,0,0,462,402h-2.35a10,10,0,0,0-9.95,10.22c1.22,44.54,23.08,59.49,24,60.11a6.31,6.31,0,0,0,3.48,1H523.8a6.34,6.34,0,0,0,3.48-1c.93-.62,22.79-15.57,24-60.11A10,10,0,0,0,541.34,402H540.2a13.08,13.08,0,0,0-4.51-5.21A35.58,35.58,0,0,0,540.5,391.81Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M483.73,375.83,486,377l.57.32a23.14,23.14,0,0,1,.11-13.19l.59-1.91-13.52-19.54,9.22,31C483.21,374.44,483.45,375.14,483.73,375.83Z"
          ></path>
          <path
            class="svg-fill"
            d="M518.7,377.36l.56-.32,2.31-1.21c.27-.69.52-1.39.73-2.1l9.22-31L518,362.26l.58,1.91A23.06,23.06,0,0,1,518.7,377.36Z"
          ></path>
          <path
            class="svg-fill"
            d="M496.36,402.1l3.85.2-1-3.72c-1.14-4.3-5.25-9.07-10.3-12l-28-16.16,21.63,24.07C486.39,398.85,491.92,401.87,496.36,402.1Z"
          ></path>
          <path
            class="svg-fill"
            d="M507.08,402.3l3.84-.2c4.45-.23,10-3.25,13.87-7.59l21.62-24.07-28,16.16c-5,2.91-9.15,7.68-10.3,12Z"
          ></path>
          <path
            class="svg-fill"
            d="M543.69,411.94h-6.21a7.39,7.39,0,0,0-7.39-7.39H504.7l.79-1.08,0-6.05a18.48,18.48,0,0,1,2.88-9.37c0-.06,0-.13,0-.2l-.15-.93a19.11,19.11,0,0,0,3-15.43l-8-35-8,35a19.07,19.07,0,0,0,3,15.48l-.14.88c0,.09,0,.17,0,.26a18.31,18.31,0,0,1,2.86,9.31l0,6,.82,1.13h-25a7.39,7.39,0,0,0-7.4,7.39H462a3.64,3.64,0,0,0-3.63,3.73c1.14,41.76,21.18,55,21.18,55h46.58s20-13.24,21.17-55A3.63,3.63,0,0,0,543.69,411.94Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M456,412.09c1.14,41.76,21.17,55,21.17,55h46.59s20-13.24,21.17-55a3.64,3.64,0,0,0-3.63-3.73H459.65A3.63,3.63,0,0,0,456,412.09Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M473.36,401h55.46a6.29,6.29,0,0,1,6.29,6.29v1.11a0,0,0,0,1,0,0h-68a0,0,0,0,1,0,0v-1.11A6.29,6.29,0,0,1,473.36,401Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M567.52,347.08l-49.83,26.23c-9,4.73-15,12.84-15,20.37l0,6.52,7.94,0a33.17,33.17,0,0,0,24.87-12.27Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M433.41,347.08l49.83,26.23c9,4.73,14.94,12.84,15,20.37l0,6.52-8,0a33.16,33.16,0,0,1-24.86-12.27Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M517.17,373.6a23.17,23.17,0,0,0-.13-13.17l-16.56-54-16.56,54a23.18,23.18,0,0,0-.11,13.2c7.22,4,12.39,10.14,13.92,16.36l2.75,2,2.71-1.93C504.72,383.78,509.91,377.58,517.17,373.6Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M517.47,372.38a1.55,1.55,0,0,1,.22-.12l10.54-5.55L536,322.49l-22,28,3,9.93A23.14,23.14,0,0,1,517.47,372.38Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M502.94,390.21l-.34.24.24.45C502.87,390.67,502.9,390.44,502.94,390.21Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M483.24,372.26l.26.14a23.11,23.11,0,0,1,.42-12l2.54-8.27-22.61-28.79L471.34,366Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M319.83,438.66V423.45H429.11c6.82,0,18.27,3.1,18.27,23.83s-11.45,23.82-18.27,23.82H319.83V455.9h5.57c1.91-3,1.91-14.27,0-17.24Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M327.66,430.52H432.72c10.84,0,14.06,8.78,14.06,19.62s-3.22,19.61-14.06,19.61H327.66V463h52.51c7.93,0,8.8-5.75,8.8-12.83s-1.4-12.84-8.8-12.84H327.66Z"
          ></path>
          <path
            class="svg-fill"
            d="M337.82,440.25H375.6a.79.79,0,0,1,.79.8.79.79,0,0,1-.79.79H337.82a.79.79,0,0,1-.8-.79A.8.8,0,0,1,337.82,440.25Z"
          ></path>
          <path
            class="svg-fill"
            d="M373.22,458.51H335.44a.8.8,0,0,1-.8-.8.79.79,0,0,1,.8-.79h37.78a.79.79,0,0,1,.79.79A.8.8,0,0,1,373.22,458.51Z"
          ></path>
          <path
            class="svg-fill"
            d="M383,452.61a.79.79,0,0,1-.79.79H338.61a.79.79,0,0,1-.79-.79.79.79,0,0,1,.79-.8h43.57A.8.8,0,0,1,383,452.61Z"
          ></path>
          <path
            class="svg-fill"
            d="M357.19,447.35a.79.79,0,0,1-.79.8H335.71a.8.8,0,0,1-.79-.8.79.79,0,0,1,.79-.79H356.4A.79.79,0,0,1,357.19,447.35Z"
          ></path>
          <path
            class="svg-fill"
            d="M368.13,446.56a.79.79,0,0,1,.8.79.8.8,0,0,1-.8.8h-3.61a.8.8,0,0,1-.79-.8.79.79,0,0,1,.79-.79Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M376.55,459.39c7.93,0,8.81-5.74,8.81-12.83s-1.4-12.83-8.81-12.83H324v-6.79h54.61c10.84,0,14.07,8.79,14.07,19.62s-3.23,19.61-14.07,19.61H324v-6.78Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M326.19,433.73c6.48,0,6.48,25.66,0,25.66"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M374.5,426.94h54.61c10.83,0,14.06,8.79,14.06,19.62s-3.23,19.61-14.06,19.61H374.5"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M145.45,437.77v-15.2H136c1.87-3.51,3.09-8.38,3.09-15.13,0-20.73-11.45-23.83-18.27-23.83H103.31a17.29,17.29,0,0,0,.7-4.75v-.69c0-.25.27,1.66.53,1.59,6.29-1.9,14.74-7.75,17.66-14.23,5.24-11.61-2-26-12.28-30.88A18.38,18.38,0,0,0,104,333v-7H46v54.43a15.51,15.51,0,0,0,.32,3.15H11.58v15.21h5.57c1.9,3,1.9,14.27,0,17.24H11.58v15.21H21c-1.87,3.51-3.08,8.38-3.08,15.13,0,20.73,11.44,23.82,18.27,23.82H145.45V455h-5.58c-1.9-3-1.9-14.28,0-17.25Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M146,429.64H132c5.82-2.84,7.76-9.94,7.76-18.29,0-10.83-3.23-19.61-14.06-19.61H96.5c3.54-1.47,6.12-5.83,6.12-9.73v-.68a7.42,7.42,0,0,1,5.45-7.08,17.27,17.27,0,0,0,10.54-9.48c3.78-8.2,1.11-17.48-6-20.75a13,13,0,0,0-10-.25v-6.69H57v46.54a8.64,8.64,0,0,0,5.72,8.12H20.6v6.78H73.11c7.4,0,8.8,5.74,8.8,12.83s-.87,12.83-8.8,12.83H20.6V431H34.68c-5.83,2.83-7.76,9.94-7.76,18.28,0,10.84,3.22,19.62,14.06,19.62H146v-6.78H93.53c-7.93,0-8.8-5.75-8.8-12.84s1.4-12.83,8.8-12.83H146Zm-43.42-79.43a8.34,8.34,0,0,1,6.73,0c4.49,2.08,6.19,8,3.79,13.19-2.06,4.47-6.47,7-10.52,6.27Z"
          ></path>
          <path
            class="svg-fill"
            d="M135.88,439.37H98.1a.8.8,0,0,0,0,1.59h37.78a.8.8,0,1,0,0-1.59Z"
          ></path>
          <path
            class="svg-fill"
            d="M100.48,457.62h37.78a.79.79,0,1,0,0-1.58H100.48a.79.79,0,1,0,0,1.58Z"
          ></path>
          <path
            class="svg-fill"
            d="M90.73,451.73a.8.8,0,0,0,.79.79h43.57a.8.8,0,0,0,0-1.59H91.52A.8.8,0,0,0,90.73,451.73Z"
          ></path>
          <path
            class="svg-fill"
            d="M116.51,446.47a.79.79,0,0,0,.79.79H138a.79.79,0,1,0,0-1.58H117.3A.79.79,0,0,0,116.51,446.47Z"
          ></path>
          <path
            class="svg-fill"
            d="M105.57,445.68a.79.79,0,1,0,0,1.58h3.6a.79.79,0,1,0,0-1.58Z"
          ></path>
          <path
            class="svg-fill"
            d="M68.54,401.47H30.76a.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8H68.54a.79.79,0,0,0,.79-.8A.79.79,0,0,0,68.54,401.47Z"
          ></path>
          <path
            class="svg-fill"
            d="M27.59,418.93a.79.79,0,0,0,.79.79H66.16a.79.79,0,0,0,.79-.79.79.79,0,0,0-.79-.8H28.38A.79.79,0,0,0,27.59,418.93Z"
          ></path>
          <path
            class="svg-fill"
            d="M30.76,413.82a.8.8,0,0,0,.79.8H75.12a.8.8,0,0,0,0-1.59H31.55A.8.8,0,0,0,30.76,413.82Z"
          ></path>
          <path
            class="svg-fill"
            d="M27.86,408.57a.79.79,0,0,0,.8.79H49.34a.79.79,0,0,0,0-1.58H28.66A.79.79,0,0,0,27.86,408.57Z"
          ></path>
          <path
            class="svg-fill"
            d="M61.08,409.36a.79.79,0,0,0,0-1.58H57.47a.79.79,0,1,0,0,1.58Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M88.72,459.23c-7.92,0-8.8-5.75-8.8-12.84s1.4-12.83,8.8-12.83h52.51v-6.78H86.62c-10.83,0-14.06,8.78-14.06,19.61S75.79,466,86.62,466h54.61v-6.78Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M139.09,433.56c-6.48,0-6.48,25.67,0,25.67"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M90.78,426.78H36.17c-10.83,0-14.06,8.78-14.06,19.61S25.34,466,36.17,466H90.78"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M68.3,420.27c7.93,0,8.81-5.74,8.81-12.83s-1.41-12.83-8.81-12.83H15.79v-6.78H70.4c10.84,0,14.06,8.78,14.06,19.61s-3.22,19.62-14.06,19.62H15.79v-6.79Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M17.94,394.61c6.48,0,6.48,25.66,0,25.66"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M66.24,387.83h54.62c10.83,0,14.06,8.78,14.06,19.61s-3.23,19.62-14.06,19.62H66.24"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M51.76,331.82v46.54A8.63,8.63,0,0,0,60.39,387H88.73c4.77,0,8.63-5.47,8.63-10.24v-.69a7.43,7.43,0,0,1,5.45-7.08,17.25,17.25,0,0,0,10.54-9.47c3.78-8.2,1.11-17.49-6-20.75a13,13,0,0,0-10-.25v-6.69Zm45.6,32.61V345a8.32,8.32,0,0,1,6.72,0c4.5,2.07,6.2,8,3.8,13.18C105.82,362.62,101.41,365.12,97.36,364.43Z"
          ></path>
          <line
            class="svg-stroke-thin"
            y1="467.84"
            x2="524.99"
            y2="466.97"
          ></line>
        </svg>,
      ],
    },
    {
      title: "Software Engineer - Software AG",
      description1: (
        <p>
          As a <strong>software engineer</strong> at <em>Software AG</em>,
          I <strong>designed and implemented</strong> a new UI for the{" "}
          <em>Agile Tester Tool</em>, a software testing platform that helps
          developers and testers deliver high-quality products faster and
          easier. I <strong>increased efficiency by 30%</strong> and{" "}
          <strong>enhanced user experience</strong> with intuitive features and
          responsive design.
        </p>
      ),
      description2: (
        <p>
          I also <strong>built and launched</strong> an{" "}
          <em>Internal Semantic Search engine</em> for the organization, a
          project that <strong>won the TechInterrupt</strong> (Yearly Internal
          hackathon) and{" "}
          <strong>improved the productivity and collaboration</strong> of the
          employees. Additionally, I <strong>created and deployed</strong> a{" "}
          <em>Chatbot</em> to <strong>resolve customer issues</strong> related
          to products, <strong>leading to a 70% reduction in tickets</strong>{" "}
          for the Customer support team and{" "}
          <strong>improving customer satisfaction</strong>. Furthermore, I{" "}
          <strong>devised and tested</strong> a{" "}
          <em>system failure prediction</em> algorithm to{" "}
          <strong>achieve a dedication to providing 99.99% availability</strong>{" "}
          to customers,{" "}
          <strong>showing exceptional accuracy and reliability</strong>.
        </p>
      ),
      illustrationSvg: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M495.76,114.63H362.5L308.56,80.41a13,13,0,0,0-5.28-8A13,13,0,0,0,279.84,78L222,114.63H83.22a14.2,14.2,0,0,0-14.11,14.29V371.07a14.2,14.2,0,0,0,14.11,14.28H495.76a14.19,14.19,0,0,0,14.11-14.28V128.92A14.2,14.2,0,0,0,495.76,114.63ZM281.7,86.75a13.17,13.17,0,0,0,3.51,3.7,13,13,0,0,0,21.87-1l39.7,25.18h-109Z"
          ></path>
          <rect class="svg-bg" y="467.84" width="596.6" height="86.55"></rect>
        </svg>
      ),
      illustrationLayers: [
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 1920 1080"
          enable-background="new 0 0 1920 1080"
        >
          <path
            fill="#102451"
            opacity="1.000000"
            stroke="none"
            d=" M1.500000,1.000000   C1.999988,360.697601 1.999975,720.395203 1.999975,1080.546387   C1.666653,1080.833374 1.056187,1080.684204 1.044447,1080.497192   C0.960992,1079.169067 1.000000,1077.833374 1.000000,1076.500000   C1.000000,718.000000 1.000000,359.500000 1.500000,1.000000  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M940.692871,443.213928   C944.565552,442.657257 944.858765,444.615509 944.830322,447.339081   C944.721252,457.799622 944.786072,468.261932 944.786072,479.255951   C956.527710,479.255951 967.922180,479.255951 979.574341,479.255951   C979.574341,488.194855 979.574341,496.601166 979.574341,505.540466   C968.061707,505.540466 956.659180,505.540466 945.026978,505.540466   C945.026978,528.831482 945.026978,551.593567 945.026978,574.808777   C956.415833,574.808777 967.834351,574.808777 979.545532,574.808777   C979.545532,583.677734 979.545532,592.103638 979.545532,600.854980   C978.954773,600.981323 978.197815,601.284851 977.441284,601.283936   C965.114075,601.269043 952.777832,601.497803 940.462036,601.099792   C924.942932,600.598206 916.199768,591.569885 916.063110,576.026062   C915.872620,554.370178 916.001038,532.711426 915.993042,511.053894   C915.992432,509.416321 915.992920,507.778717 915.992920,505.885986   C896.230591,505.885986 876.821838,505.885986 856.954102,505.885986   C856.954102,537.424866 856.954102,568.996277 856.954102,600.940186   C847.111755,600.940186 837.718445,600.940186 827.970947,600.940186   C827.970947,569.318848 827.970947,537.718689 827.970947,505.646942   C819.231873,505.646942 810.829773,505.646942 802.198486,505.646942   C802.198486,496.747070 802.198486,488.318298 802.198486,479.436829   C810.654968,479.436829 819.072449,479.436829 827.993042,479.436829   C827.993042,472.045929 827.972595,465.093475 827.997009,458.141144   C828.060120,440.145752 836.464722,431.258392 854.308777,430.807953   C865.963196,430.513794 877.630127,430.713776 889.291443,430.706543   C889.762329,430.706238 890.233398,430.851196 890.934631,430.966309   C890.934631,439.439911 890.934631,447.873169 890.934631,456.785583   C879.684814,456.785583 868.463501,456.785583 856.983765,456.785583   C856.983765,464.344727 856.983765,471.434418 856.983765,478.905823   C876.423035,478.905823 895.959229,478.905823 915.946289,478.905823   C915.946289,467.222992 915.946289,455.472412 915.946289,443.213806   C924.331421,443.213806 932.278748,443.213806 940.692871,443.213928  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1085.229492,518.928101   C1084.673340,517.143982 1084.231812,515.736450 1083.477905,513.332581   C1074.735474,543.238464 1066.276611,572.174316 1057.759521,601.309326   C1048.040649,601.309326 1038.561890,601.470276 1029.101562,601.125854   C1027.770630,601.077393 1025.852539,598.768738 1025.346924,597.150024   C1015.443848,565.445251 1005.710388,533.687500 995.941223,501.940918   C993.656921,494.517548 991.368896,487.095276 988.964661,479.289612   C998.825073,479.289612 1008.146606,479.129883 1017.449768,479.472076   C1018.755798,479.520111 1020.661499,481.826172 1021.125122,483.424744   C1027.880005,506.715881 1034.433228,530.065491 1041.046753,553.397644   C1041.578979,555.274963 1042.201172,557.126709 1043.253174,560.505005   C1046.775024,548.381470 1049.889282,537.718140 1052.968994,527.044800   C1057.113770,512.681091 1061.377563,498.348938 1065.263550,483.915253   C1066.293579,480.089661 1068.017212,479.040771 1071.813477,479.193604   C1079.630127,479.508240 1087.486938,479.611542 1095.290283,479.160614   C1099.605347,478.911224 1100.922729,480.661591 1101.969482,484.393311   C1108.564087,507.901886 1115.377808,531.348999 1122.130859,554.813049   C1122.517090,556.155029 1123.005249,557.467590 1124.487305,558.847168   C1132.040527,532.462097 1139.593750,506.077087 1147.195435,479.522705   C1157.440552,479.522705 1167.516113,479.522705 1178.103027,479.522705   C1165.553345,520.197693 1153.086426,560.604980 1140.586304,601.119507   C1130.215454,601.119507 1120.083130,601.119507 1109.315308,601.119507   C1101.365601,573.986877 1093.354858,546.645752 1085.229492,518.928101  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1216.465698,481.398682   C1229.558105,476.305634 1242.642090,475.150085 1256.007324,478.029724   C1264.991455,479.965515 1272.683716,484.328735 1279.646240,492.304138   C1279.646240,487.258209 1279.646240,483.440430 1279.646240,479.465881   C1289.393921,479.465881 1298.514038,479.465881 1307.972656,479.465881   C1307.972656,519.906738 1307.972656,560.286743 1307.972656,600.988770   C1298.843628,600.988770 1289.607910,600.988770 1279.763062,600.988770   C1279.763062,597.244507 1279.763062,593.377563 1279.763062,589.500610   C1278.852173,589.500610 1278.421387,589.367126 1278.259644,589.519470   C1246.819702,619.138550 1193.350586,602.441040 1182.068359,559.466187   C1174.930664,532.278198 1183.254272,504.297394 1203.281250,489.133820   C1207.214600,486.155579 1211.829102,484.077026 1216.465698,481.398682  M1210.910645,527.611023   C1210.394409,530.046936 1209.663086,532.459412 1209.395264,534.922241   C1206.724976,559.477234 1221.620605,579.340271 1247.831665,578.040100   C1268.135010,577.032959 1281.592163,561.219299 1281.074829,538.515015   C1280.651978,519.959595 1269.228760,506.031677 1252.080078,503.162842   C1233.103394,499.988190 1217.738525,508.854279 1210.910645,527.611023  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1472.999512,548.400757   C1462.056519,548.400696 1451.613647,548.400696 1441.189209,548.400696   C1440.975342,559.443542 1449.547729,571.284668 1460.757935,575.967651   C1477.149780,582.815125 1495.160278,578.160339 1509.731079,563.130249   C1517.073853,568.436218 1524.456421,573.771057 1532.113037,579.303772   C1524.938843,588.632446 1516.270020,595.646667 1505.381958,599.495239   C1488.947144,605.304260 1472.092651,606.149231 1455.311157,601.445923   C1423.027710,592.397949 1407.745483,562.927917 1411.499268,532.001038   C1418.574829,473.708954 1482.076782,465.723969 1513.609619,487.311096   C1529.901611,498.464478 1537.518799,514.501648 1538.840942,533.809814   C1539.158203,538.442627 1538.888184,543.115662 1538.888184,548.400818   C1517.002075,548.400818 1495.250732,548.400818 1472.999512,548.400757  M1481.865479,501.341461   C1462.201660,499.372986 1446.467285,508.802887 1442.547119,524.887329   C1464.607666,524.887329 1486.672485,524.887329 1509.177368,524.887329   C1504.670044,511.722931 1495.938721,504.101166 1481.865479,501.341461  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M799.765869,532.383850   C801.684021,558.191956 794.028870,579.681885 771.828979,593.328857   C747.155945,608.495972 721.168457,608.552734 696.010864,594.210083   C673.612000,581.440308 662.559998,555.033264 667.301636,528.932617   C672.116577,502.428406 691.334900,482.791077 717.659363,478.054657   C740.749695,473.900208 762.120178,477.631378 780.204529,493.640839   C791.665222,503.786499 797.654175,516.897339 799.765869,532.383850  M712.488220,572.126709   C726.995178,580.215332 741.513000,580.322632 755.371887,571.054626   C770.128479,561.186279 774.848206,539.565063 766.572205,522.693604   C758.719666,506.685333 739.806396,499.015137 721.437561,504.607117   C707.964844,508.708527 699.684204,517.947937 697.067200,531.659363   C693.986450,547.800903 698.006653,561.690857 712.488220,572.126709  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M600.100342,604.083252   C578.694397,602.361511 561.395325,594.810425 551.351624,574.348877   C560.313171,569.524536 568.880310,564.912537 577.681091,560.174805   C582.490784,568.518250 588.754944,574.980530 598.243530,577.334473   C605.201477,579.060425 612.142761,578.691650 618.801819,575.931335   C623.001404,574.190552 626.338562,571.449829 626.386841,566.399231   C626.432617,561.603271 623.535461,558.367432 619.398438,557.033203   C612.005920,554.649048 604.344604,553.113525 596.868530,550.969299   C588.922607,548.690430 580.526672,547.167664 573.263489,543.473877   C551.742859,532.529053 548.887573,504.582367 567.179626,488.768799   C577.078247,480.211456 588.903687,476.777802 601.730469,476.567047   C621.784485,476.237549 639.239319,481.689178 650.821533,499.546936   C651.617798,500.774567 652.248474,502.109528 653.084595,503.627808   C645.249756,508.325409 637.578918,512.924683 629.774292,517.604126   C621.772034,505.769409 610.933350,500.885468 597.036255,502.949829   C589.781738,504.027466 584.673950,507.578064 584.045532,512.074829   C583.379028,516.844116 586.773376,521.309570 594.572571,523.557434   C603.805542,526.218445 613.354858,527.768005 622.732483,529.948120   C626.279175,530.772644 629.810547,531.800171 633.209290,533.100159   C646.507935,538.186768 654.551208,547.432190 655.538635,562.050171   C656.495300,576.212463 651.265198,587.442505 639.321960,595.234619   C627.539246,602.922119 614.293274,604.622559 600.100342,604.083252  z"
          />
          <path
            fill="#FCFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M320.108215,430.958984   C320.267517,403.341003 340.903137,380.499115 368.875031,379.354919   C396.301147,378.233063 423.809052,379.110535 451.586761,379.110535   C451.586761,396.179474 451.586761,413.097778 451.586761,430.775330   C408.100098,430.775330 364.522980,430.775330 320.478210,430.872101   C320.010559,430.968872 320.108215,430.958984 320.108215,430.958984  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M441.862274,601.053345   C441.422577,629.834900 419.279236,652.525818 390.589600,652.918335   C364.444214,653.276123 338.290131,652.999878 312.139862,652.991699   C311.514984,652.991516 310.890137,652.856384 310.109070,652.766113   C310.109070,635.624756 310.109070,618.705444 310.109070,601.241089   C353.860870,601.241089 397.443542,601.241089 441.492859,601.140259   C441.959473,601.039490 441.862274,601.053345 441.862274,601.053345  z"
          />
          <path
            fill="#FDFDFD"
            opacity="1.000000"
            stroke="none"
            d=" M1351.805908,601.309937   C1344.680542,601.309875 1338.030396,601.309875 1331.066772,601.309875   C1330.976318,599.565125 1330.836792,598.120789 1330.836182,596.676453   C1330.823730,566.677490 1330.800903,536.678467 1330.837158,506.679565   C1330.858398,489.149567 1338.423584,480.362518 1355.749512,479.618256   C1372.521729,478.897797 1389.349243,479.462036 1406.496338,479.462036   C1406.496338,488.209015 1406.496338,496.759552 1406.496338,505.828369   C1390.848511,505.828369 1375.267090,505.828369 1359.379517,505.828369   C1359.379517,537.785217 1359.379517,569.230347 1359.379517,601.309937   C1356.810913,601.309937 1354.546143,601.309937 1351.805908,601.309937  z"
          />
          <path
            fill="#6380D5"
            opacity="1.000000"
            stroke="none"
            d=" M351.166687,479.578674   C373.286255,486.486664 395.405792,493.394684 417.779541,501.016113   C418.020844,516.975647 418.051453,532.222107 417.950836,547.467590   C417.934723,549.911011 417.331696,552.350586 416.999969,554.791931   C397.647095,544.423218 376.058960,541.035461 355.306549,535.037598   C354.036682,534.670593 352.767395,534.301636 351.220947,533.259033   C351.018250,514.915894 351.092468,497.247284 351.166687,479.578674  z"
          />
          <path
            fill="#4DA5C3"
            opacity="1.000000"
            stroke="none"
            d=" M417.263916,555.014954   C417.331696,552.350586 417.934723,549.911011 417.950836,547.467590   C418.051453,532.222107 418.020844,516.975647 418.056976,501.243164   C432.356598,504.739655 445.624969,510.871887 457.578278,519.773315   C456.916840,521.983704 456.065552,523.794739 456.059235,525.608704   C455.971893,550.702454 456.000610,575.796570 456.000885,600.890625   C451.603882,600.950439 447.206848,601.010315 442.336060,601.061768   C441.862274,601.053345 441.959473,601.039490 441.956116,601.088928   C441.317169,586.556885 438.275238,572.871094 426.936096,562.496460   C424.024048,559.832092 420.675751,557.644592 417.263916,555.014954  z"
          />
          <path
            fill="#47AFBE"
            opacity="1.000000"
            stroke="none"
            d=" M456.464905,600.961731   C456.000610,575.796570 455.971893,550.702454 456.059235,525.608704   C456.065552,523.794739 456.916840,521.983704 457.772186,520.055176   C476.431274,532.443298 487.147156,550.033691 491.762848,571.313782   C493.816742,580.782898 494.416351,590.567444 495.783722,601.032837   C482.017670,601.032837 469.473297,601.032837 456.464905,600.961731  z"
          />
          <path
            fill="#7D57E9"
            opacity="1.000000"
            stroke="none"
            d=" M320.012543,430.919830   C320.475586,440.420441 322.049622,449.687042 326.986755,458.939117   C327.020844,478.367767 327.096466,496.967834 326.908051,515.565186   C326.879395,518.395508 325.626831,521.213501 324.940369,524.037170   C316.320435,518.929077 307.700470,513.820923 299.312805,508.292908   C300.029999,506.072113 300.930115,504.272888 300.937134,502.470154   C301.029510,478.683502 300.996155,454.896332 300.994293,431.109314   C307.048767,431.050598 313.103241,430.991852 319.632965,430.946045   C320.108215,430.958984 320.010559,430.968872 320.012543,430.919830  z"
          />
          <path
            fill="#8647F0"
            opacity="1.000000"
            stroke="none"
            d=" M300.530670,431.038330   C300.996155,454.896332 301.029510,478.683502 300.937134,502.470154   C300.930115,504.272888 300.029999,506.072113 299.142365,507.994904   C290.099243,501.857910 283.848541,493.551849 278.834412,484.308014   C269.912415,467.859741 267.034912,450.037964 267.004028,430.967316   C278.270538,430.967316 289.168793,430.967316 300.530670,431.038330  z"
          />
          <path
            fill="#7465E2"
            opacity="1.000000"
            stroke="none"
            d=" M325.179688,524.295044   C325.626831,521.213501 326.879395,518.395508 326.908051,515.565186   C327.096466,496.967834 327.020844,478.367767 327.054138,459.285828   C333.216583,467.591370 341.177460,474.264801 350.928284,479.357574   C351.092468,497.247284 351.018250,514.915894 350.909485,533.099182   C342.389648,530.593567 333.904297,527.573181 325.179688,524.295044  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M1654.904907,507.616394   C1651.840210,520.929138 1643.888184,527.522522 1631.434570,527.483276   C1619.358521,527.445190 1609.799194,519.846191 1607.314209,508.309509   C1604.904297,497.121338 1610.579590,485.669067 1620.867676,480.959625   C1631.792603,475.958679 1644.961792,479.034882 1652.212891,488.668457   C1649.652588,490.377563 1647.099609,492.081818 1644.565063,493.773834   C1636.162231,487.274048 1629.390747,486.141449 1623.348022,490.190002   C1617.862427,493.865204 1615.370361,501.249725 1617.370605,507.901398   C1619.240967,514.121094 1624.475708,518.072449 1631.104736,518.268372   C1637.791626,518.465881 1641.451416,516.127014 1643.829834,509.812927   C1638.943726,509.812927 1634.202148,509.812927 1629.198730,509.812927   C1629.198730,507.130188 1629.198730,504.858643 1629.198730,502.226013   C1637.549683,502.226013 1646.086182,502.226013 1654.942383,502.226013   C1654.942383,503.933105 1654.942383,505.555939 1654.904907,507.616394  z"
          />
          <path
            fill="#FBFCFC"
            opacity="1.000000"
            stroke="none"
            d=" M1571.225342,488.134521   C1571.849609,486.722137 1572.342529,485.669281 1572.796631,484.599976   C1574.860107,479.739624 1579.626953,477.564362 1584.530396,479.414978   C1585.312744,479.710205 1586.063965,480.641144 1586.410767,481.456360   C1592.648315,496.124298 1598.823853,510.818665 1604.988403,525.517639   C1605.095703,525.773376 1604.902832,526.155029 1604.820190,526.661194   C1601.393799,526.661194 1597.942261,526.661194 1594.341553,526.661194   C1592.878052,523.158630 1591.412720,519.651611 1589.904175,516.040894   C1586.729004,516.040894 1583.697510,516.348633 1580.750977,515.979248   C1573.823242,515.110779 1568.440674,516.197815 1567.026001,524.395264   C1566.855225,525.385315 1564.795044,526.551575 1563.483643,526.736389   C1560.875244,527.103943 1558.178467,526.845093 1554.898804,526.845093   C1560.395630,513.811462 1565.735962,501.148956 1571.225342,488.134521  M1585.770874,505.142273   C1584.058228,500.834778 1582.345703,496.527313 1580.250488,491.257538   C1578.086060,496.879578 1576.219727,501.727417 1573.897827,507.758728   C1578.637451,507.057953 1582.306274,506.515503 1585.770874,505.142273  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M1210.993652,527.217163   C1217.738525,508.854279 1233.103394,499.988190 1252.080078,503.162842   C1269.228760,506.031677 1280.651978,519.959595 1281.074829,538.515015   C1281.592163,561.219299 1268.135010,577.032959 1247.831665,578.040100   C1221.620605,579.340271 1206.724976,559.477234 1209.395264,534.922241   C1209.663086,532.459412 1210.394409,530.046936 1210.993652,527.217163  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M1482.287476,501.448914   C1495.938721,504.101166 1504.670044,511.722931 1509.177368,524.887329   C1486.672485,524.887329 1464.607666,524.887329 1442.547119,524.887329   C1446.467285,508.802887 1462.201660,499.372986 1482.287476,501.448914  z"
          />
          <path
            fill="#03203E"
            opacity="1.000000"
            stroke="none"
            d=" M712.166443,571.953491   C698.006653,561.690857 693.986450,547.800903 697.067200,531.659363   C699.684204,517.947937 707.964844,508.708527 721.437561,504.607117   C739.806396,499.015137 758.719666,506.685333 766.572205,522.693604   C774.848206,539.565063 770.128479,561.186279 755.371887,571.054626   C741.513000,580.322632 726.995178,580.215332 712.166443,571.953491  z"
          />
          <path
            fill="#102451"
            opacity="1.000000"
            stroke="none"
            d=" M1585.873047,505.557678   C1582.306274,506.515503 1578.637451,507.057953 1573.897827,507.758728   C1576.219727,501.727417 1578.086060,496.879578 1580.250488,491.257538   C1582.345703,496.527313 1584.058228,500.834778 1585.873047,505.557678  z"
          />
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M540.5,391.81l32-40.84a6.31,6.31,0,0,0-7.91-9.48l-28.11,14.79,5.74-32.7a6.31,6.31,0,0,0-11.19-5l-14.53,18.5-10-32.5a6.32,6.32,0,0,0-12.08,0L484,338.76l-15.14-19.29a6.32,6.32,0,0,0-11.19,5l5.46,31.09-26.74-14.07a6.31,6.31,0,0,0-7.91,9.48l32,40.84a36.36,36.36,0,0,0,5.38,5.51A13,13,0,0,0,462,402h-2.35a10,10,0,0,0-9.95,10.22c1.22,44.54,23.08,59.49,24,60.11a6.31,6.31,0,0,0,3.48,1H523.8a6.34,6.34,0,0,0,3.48-1c.93-.62,22.79-15.57,24-60.11A10,10,0,0,0,541.34,402H540.2a13.08,13.08,0,0,0-4.51-5.21A35.58,35.58,0,0,0,540.5,391.81Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M483.73,375.83,486,377l.57.32a23.14,23.14,0,0,1,.11-13.19l.59-1.91-13.52-19.54,9.22,31C483.21,374.44,483.45,375.14,483.73,375.83Z"
          ></path>
          <path
            class="svg-fill"
            d="M518.7,377.36l.56-.32,2.31-1.21c.27-.69.52-1.39.73-2.1l9.22-31L518,362.26l.58,1.91A23.06,23.06,0,0,1,518.7,377.36Z"
          ></path>
          <path
            class="svg-fill"
            d="M496.36,402.1l3.85.2-1-3.72c-1.14-4.3-5.25-9.07-10.3-12l-28-16.16,21.63,24.07C486.39,398.85,491.92,401.87,496.36,402.1Z"
          ></path>
          <path
            class="svg-fill"
            d="M507.08,402.3l3.84-.2c4.45-.23,10-3.25,13.87-7.59l21.62-24.07-28,16.16c-5,2.91-9.15,7.68-10.3,12Z"
          ></path>
          <path
            class="svg-fill"
            d="M543.69,411.94h-6.21a7.39,7.39,0,0,0-7.39-7.39H504.7l.79-1.08,0-6.05a18.48,18.48,0,0,1,2.88-9.37c0-.06,0-.13,0-.2l-.15-.93a19.11,19.11,0,0,0,3-15.43l-8-35-8,35a19.07,19.07,0,0,0,3,15.48l-.14.88c0,.09,0,.17,0,.26a18.31,18.31,0,0,1,2.86,9.31l0,6,.82,1.13h-25a7.39,7.39,0,0,0-7.4,7.39H462a3.64,3.64,0,0,0-3.63,3.73c1.14,41.76,21.18,55,21.18,55h46.58s20-13.24,21.17-55A3.63,3.63,0,0,0,543.69,411.94Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M456,412.09c1.14,41.76,21.17,55,21.17,55h46.59s20-13.24,21.17-55a3.64,3.64,0,0,0-3.63-3.73H459.65A3.63,3.63,0,0,0,456,412.09Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M473.36,401h55.46a6.29,6.29,0,0,1,6.29,6.29v1.11a0,0,0,0,1,0,0h-68a0,0,0,0,1,0,0v-1.11A6.29,6.29,0,0,1,473.36,401Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M567.52,347.08l-49.83,26.23c-9,4.73-15,12.84-15,20.37l0,6.52,7.94,0a33.17,33.17,0,0,0,24.87-12.27Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M433.41,347.08l49.83,26.23c9,4.73,14.94,12.84,15,20.37l0,6.52-8,0a33.16,33.16,0,0,1-24.86-12.27Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M517.17,373.6a23.17,23.17,0,0,0-.13-13.17l-16.56-54-16.56,54a23.18,23.18,0,0,0-.11,13.2c7.22,4,12.39,10.14,13.92,16.36l2.75,2,2.71-1.93C504.72,383.78,509.91,377.58,517.17,373.6Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M517.47,372.38a1.55,1.55,0,0,1,.22-.12l10.54-5.55L536,322.49l-22,28,3,9.93A23.14,23.14,0,0,1,517.47,372.38Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M502.94,390.21l-.34.24.24.45C502.87,390.67,502.9,390.44,502.94,390.21Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M483.24,372.26l.26.14a23.11,23.11,0,0,1,.42-12l2.54-8.27-22.61-28.79L471.34,366Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M319.83,438.66V423.45H429.11c6.82,0,18.27,3.1,18.27,23.83s-11.45,23.82-18.27,23.82H319.83V455.9h5.57c1.91-3,1.91-14.27,0-17.24Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M327.66,430.52H432.72c10.84,0,14.06,8.78,14.06,19.62s-3.22,19.61-14.06,19.61H327.66V463h52.51c7.93,0,8.8-5.75,8.8-12.83s-1.4-12.84-8.8-12.84H327.66Z"
          ></path>
          <path
            class="svg-fill"
            d="M337.82,440.25H375.6a.79.79,0,0,1,.79.8.79.79,0,0,1-.79.79H337.82a.79.79,0,0,1-.8-.79A.8.8,0,0,1,337.82,440.25Z"
          ></path>
          <path
            class="svg-fill"
            d="M373.22,458.51H335.44a.8.8,0,0,1-.8-.8.79.79,0,0,1,.8-.79h37.78a.79.79,0,0,1,.79.79A.8.8,0,0,1,373.22,458.51Z"
          ></path>
          <path
            class="svg-fill"
            d="M383,452.61a.79.79,0,0,1-.79.79H338.61a.79.79,0,0,1-.79-.79.79.79,0,0,1,.79-.8h43.57A.8.8,0,0,1,383,452.61Z"
          ></path>
          <path
            class="svg-fill"
            d="M357.19,447.35a.79.79,0,0,1-.79.8H335.71a.8.8,0,0,1-.79-.8.79.79,0,0,1,.79-.79H356.4A.79.79,0,0,1,357.19,447.35Z"
          ></path>
          <path
            class="svg-fill"
            d="M368.13,446.56a.79.79,0,0,1,.8.79.8.8,0,0,1-.8.8h-3.61a.8.8,0,0,1-.79-.8.79.79,0,0,1,.79-.79Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M376.55,459.39c7.93,0,8.81-5.74,8.81-12.83s-1.4-12.83-8.81-12.83H324v-6.79h54.61c10.84,0,14.07,8.79,14.07,19.62s-3.23,19.61-14.07,19.61H324v-6.78Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M326.19,433.73c6.48,0,6.48,25.66,0,25.66"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M374.5,426.94h54.61c10.83,0,14.06,8.79,14.06,19.62s-3.23,19.61-14.06,19.61H374.5"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-bg"
            d="M145.45,437.77v-15.2H136c1.87-3.51,3.09-8.38,3.09-15.13,0-20.73-11.45-23.83-18.27-23.83H103.31a17.29,17.29,0,0,0,.7-4.75v-.69c0-.25.27,1.66.53,1.59,6.29-1.9,14.74-7.75,17.66-14.23,5.24-11.61-2-26-12.28-30.88A18.38,18.38,0,0,0,104,333v-7H46v54.43a15.51,15.51,0,0,0,.32,3.15H11.58v15.21h5.57c1.9,3,1.9,14.27,0,17.24H11.58v15.21H21c-1.87,3.51-3.08,8.38-3.08,15.13,0,20.73,11.44,23.82,18.27,23.82H145.45V455h-5.58c-1.9-3-1.9-14.28,0-17.25Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-fill"
            d="M146,429.64H132c5.82-2.84,7.76-9.94,7.76-18.29,0-10.83-3.23-19.61-14.06-19.61H96.5c3.54-1.47,6.12-5.83,6.12-9.73v-.68a7.42,7.42,0,0,1,5.45-7.08,17.27,17.27,0,0,0,10.54-9.48c3.78-8.2,1.11-17.48-6-20.75a13,13,0,0,0-10-.25v-6.69H57v46.54a8.64,8.64,0,0,0,5.72,8.12H20.6v6.78H73.11c7.4,0,8.8,5.74,8.8,12.83s-.87,12.83-8.8,12.83H20.6V431H34.68c-5.83,2.83-7.76,9.94-7.76,18.28,0,10.84,3.22,19.62,14.06,19.62H146v-6.78H93.53c-7.93,0-8.8-5.75-8.8-12.84s1.4-12.83,8.8-12.83H146Zm-43.42-79.43a8.34,8.34,0,0,1,6.73,0c4.49,2.08,6.19,8,3.79,13.19-2.06,4.47-6.47,7-10.52,6.27Z"
          ></path>
          <path
            class="svg-fill"
            d="M135.88,439.37H98.1a.8.8,0,0,0,0,1.59h37.78a.8.8,0,1,0,0-1.59Z"
          ></path>
          <path
            class="svg-fill"
            d="M100.48,457.62h37.78a.79.79,0,1,0,0-1.58H100.48a.79.79,0,1,0,0,1.58Z"
          ></path>
          <path
            class="svg-fill"
            d="M90.73,451.73a.8.8,0,0,0,.79.79h43.57a.8.8,0,0,0,0-1.59H91.52A.8.8,0,0,0,90.73,451.73Z"
          ></path>
          <path
            class="svg-fill"
            d="M116.51,446.47a.79.79,0,0,0,.79.79H138a.79.79,0,1,0,0-1.58H117.3A.79.79,0,0,0,116.51,446.47Z"
          ></path>
          <path
            class="svg-fill"
            d="M105.57,445.68a.79.79,0,1,0,0,1.58h3.6a.79.79,0,1,0,0-1.58Z"
          ></path>
          <path
            class="svg-fill"
            d="M68.54,401.47H30.76a.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8H68.54a.79.79,0,0,0,.79-.8A.79.79,0,0,0,68.54,401.47Z"
          ></path>
          <path
            class="svg-fill"
            d="M27.59,418.93a.79.79,0,0,0,.79.79H66.16a.79.79,0,0,0,.79-.79.79.79,0,0,0-.79-.8H28.38A.79.79,0,0,0,27.59,418.93Z"
          ></path>
          <path
            class="svg-fill"
            d="M30.76,413.82a.8.8,0,0,0,.79.8H75.12a.8.8,0,0,0,0-1.59H31.55A.8.8,0,0,0,30.76,413.82Z"
          ></path>
          <path
            class="svg-fill"
            d="M27.86,408.57a.79.79,0,0,0,.8.79H49.34a.79.79,0,0,0,0-1.58H28.66A.79.79,0,0,0,27.86,408.57Z"
          ></path>
          <path
            class="svg-fill"
            d="M61.08,409.36a.79.79,0,0,0,0-1.58H57.47a.79.79,0,1,0,0,1.58Z"
          ></path>
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.6 554.39">
          <path
            class="svg-stroke-thin"
            d="M88.72,459.23c-7.92,0-8.8-5.75-8.8-12.84s1.4-12.83,8.8-12.83h52.51v-6.78H86.62c-10.83,0-14.06,8.78-14.06,19.61S75.79,466,86.62,466h54.61v-6.78Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M139.09,433.56c-6.48,0-6.48,25.67,0,25.67"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M90.78,426.78H36.17c-10.83,0-14.06,8.78-14.06,19.61S25.34,466,36.17,466H90.78"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M68.3,420.27c7.93,0,8.81-5.74,8.81-12.83s-1.41-12.83-8.81-12.83H15.79v-6.78H70.4c10.84,0,14.06,8.78,14.06,19.61s-3.22,19.62-14.06,19.62H15.79v-6.79Z"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M17.94,394.61c6.48,0,6.48,25.66,0,25.66"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M66.24,387.83h54.62c10.83,0,14.06,8.78,14.06,19.61s-3.23,19.62-14.06,19.62H66.24"
          ></path>
          <path
            class="svg-stroke-thin"
            d="M51.76,331.82v46.54A8.63,8.63,0,0,0,60.39,387H88.73c4.77,0,8.63-5.47,8.63-10.24v-.69a7.43,7.43,0,0,1,5.45-7.08,17.25,17.25,0,0,0,10.54-9.47c3.78-8.2,1.11-17.49-6-20.75a13,13,0,0,0-10-.25v-6.69Zm45.6,32.61V345a8.32,8.32,0,0,1,6.72,0c4.5,2.07,6.2,8,3.8,13.18C105.82,362.62,101.41,365.12,97.36,364.43Z"
          ></path>
          <line
            class="svg-stroke-thin"
            y1="467.84"
            x2="524.99"
            y2="466.97"
          ></line>
        </svg>,
      ],
    },
  ];

  return (
    <div className="section" style={{ textAlign: "left" }}>
      <header className="page-header" style={{ textAlign: "left" }}>
        <div className="page-header__inr">
          <div
            className="page-header__content is-onscreen"
            data-prlx="0 0.25"
            style={{ position: "relative" }}
          >
            <div className="article-heading">
              <h1 className="article-heading__title t-heading t-medium:s t-bigger:m t-biggest:l">
                <span>
                  About my work<span className="dot">.</span>
                </span>
              </h1>
            </div>
            <p className="page-header__lede t-primary lh-loose t-body:s t-sublede:m t-lede:l reveal-content">
              With a relentless commitment to innovation, I collaborate with
              visionary teams to craft captivating websites and products that
              resonate with users. From my impactful contributions at Software AG, where I spearheaded projects
              revolutionizing UI design and enhancing customer support through
              chatbot development, to my pursuit of a Bachelor of Engineering
              from Bangalore Institute of Technology, I have immersed myself in
              the dynamic realm of technology for over two years. Through
              ongoing learning and hands-on experience, I continue to push the
              boundaries of possibility, enriching the digital landscape with my
              expertise and unwavering dedication.
            </p>
            <span
              className="page-header__scroll"
              aria-hidden="true"
              style={{ textAlign: "center" }}
            >
              <span>
                <span>S</span> <span>c</span> <span>r</span> <span>o</span>{" "}
                <span>l</span> <span>l</span>
              </span>
            </span>
          </div>
        </div>
      </header>
      {listOfApproach.map((approach, index) => {
        return (
          <div
            class={`panels panels--centred ${
              index % 2 == 0 ? "" : "panels-reveresed"
            }`}
            style={
              index % 2 == 0
                ? { flexDirection: "row" }
                : { flexDirection: "row-reverse" }
            }
          >
            <div class="panels__main">
              <div class="flow">
                <h2 class="t-heading t-lede:s t-medium:m t-medium:l">
                  {approach.title}
                  <span class="dot">.</span>
                </h2>
                {approach.description1}
                {approach.description2}
              </div>
            </div>
            <div class="panels__side">
              <div class="circle">
                <div class="circle__inr is-active">
                  <div class="circle__bg stripes" data-drift="-10 -14"></div>
                  <div class="illustration illustration--board">
                    {approach.illustrationSvg}
                    {approach.illustrationLayers.map(
                      (illustrationLayer, index) => {
                        return (
                          <div
                            class="illustration__layer"
                            data-drift={index % 3 == 0 ? "-4 -4" : ""}
                          >
                            {illustrationLayer}
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div class="reveal chunk hero">
        <h2 class="hero__title t-outline t-heading t-lede:s t-big:m t-bigger:l">
          Let's build something <b>better</b>
          <span class="dot">.</span>
        </h2>
        <div class="flow hero__content">
          <div class="hero__bg dots" data-drift="-10 -14"></div>
          <p>
            I firmly advocate for the ethical responsibility of designers and
            developers in ensuring that our creations contribute positively to
            society. With a steadfast commitment to ethical practices, I
            prioritize projects aligned with values of sustainability,
            diversity, and social impact.
          </p>
          <p>
            If your organization engages in activities such as online gambling,
            payday loans, or exploitation of personal data for profit, I may not
            be the best fit for your project. Similarly, due to concerns
            regarding its significant energy consumption, I refrain from
            undertaking projects involving crypto technology in its current
            form. However, I remain open to revisiting this stance should
            advancements lead to carbon-neutral solutions that transcend mere
            offsetting practices.
          </p>
          <p>
            In essence, I am dedicated to collaborating on projects that uphold
            ethical principles and strive to foster a better, more equitable
            world. If you're seeking assistance in developing solutions that
            prioritize sustainability and positive societal impact, I am eager
            to explore potential collaborations.
          </p>
          <a
            href="mailto:nsriramula@hawk.iit.edu?subject=🤘 Hi Niraj, I'd like to hire you"
            class="btn"
          >
            <span class="btn__label">Get in touch</span>{" "}
            <span
              class="btn__fill stripes"
              data-drift="-10 -12"
              aria-hidden="true"
            >
              Get in touch
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Work;
